// extracted by mini-css-extract-plugin
module.exports = {"title":"land-for-sale_title__2tANz","sendDetailsForm":"land-for-sale_sendDetailsForm__2bBUh"};